import { useState, useEffect, useMemo } from "react";
import {
  DataGrid,
  DeleteButton,
  Grid,
  Button,
  Stack,
  Typography,
  useAutocomplete,
  Modal,
  Box,
  Checkbox,
  TextField,
} from "@pankod/refine-mui";
import { itIT } from "@mui/x-data-grid";

import { TOKEN_KEY } from "constants";
import axios from "utils/axios";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";
import useAuth from "contexts/AuthContext";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import { toast } from "react-toastify";
import { useResource } from "@pankod/refine-core";

function ModalAdd({ open, handleClose, listinoID, strutturaID }) {
  const [isNewUser, setIsNewUser] = useState(false);
  const [email, setEmail] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();

  async function addUser() {
    let body = {};
    const jwt_token = localStorage.getItem(TOKEN_KEY);
    axios.defaults.headers.common.Authorization = `Bearer ${jwt_token}`;

    if (isNewUser) {
      if ((email, firstName, lastName)) {
        body = {
          email,
          firstName,
          lastName,
          strutturaID,
          listinoID,
        };
      } else {
        toast.error("Riempire tutti i campi obbligatori");
        return;
      }
    } else {
      if (email) {
        body = {
          email,
          strutturaID,
          listinoID,
        };
      } else {
        toast.error("Riempire tutti i campi obbligatori");
        return;
      }
    }

    try {
      let res = await axios.post("/api/add-user-to-listino", body);
      toast.success("Utente aggiunto con successo al listino");
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch {
      toast.error("Problemi nell'aggiunta dell'utente");
    }
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxWidth: 800,
          minWidth: 320,
          background: "#fff",
          border: "unset",
          borderRadius: 4,
          p: 2,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h5">Aggiungi cliente al listino</Typography>
          </Grid>
          <Grid item xs={12} container alignItems="center">
            <Typography variant="body1">Crea nuovo utente:</Typography>{" "}
            <Checkbox
              checked={isNewUser}
              onChange={(e) => setIsNewUser(e.target.checked)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              type="text"
              label="Email"
              required
              InputLabelProps={{
                shrink: true,
              }}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </Grid>
          {isNewUser && (
            <>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="text"
                  label="Nome"
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="text"
                  label="Cognome"
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value);
                  }}
                />
              </Grid>
            </>
          )}
          <Grid item xs={12} container justifyContent="flex-end">
            <Button
              variant="contained"
              size="large"
              endIcon={<AddCircleIcon />}
              onClick={addUser}
            >
              Aggiungi
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default function CompFields({
  register,
  control,
  errors,
  defaultLanguageRecord,
  getValues,
  setError,
  setValue,
  watch,
  disabled,
  isCreate,
}) {
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  const { id: listinoID } = useResource();

  useEffect(() => {
    register("users");
  }, []);

  const auth = useAuth();
  const owner = auth.user?.id ? auth.user?.id : "";

  async function removeUser(userID) {
    const jwt_token = localStorage.getItem(TOKEN_KEY);
    axios.defaults.headers.common.Authorization = `Bearer ${jwt_token}`;

    let body = {
      listinoID,
      userID,
    };

    try {
      let res = await axios.post("/api/remove-user-from-listino", body);
      toast.success("Utente rimosso con successo dal listino");
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch {
      toast.error("Problemi nella rimozione dell'utente");
    }
  }

  const { autocompleteProps: facilityAC } = useAutocomplete({
    resource: "strutture",
    pagination: {
      pageSize: 999,
    },
    metaData: {
      populate: "deep,2",
    },
    filters: [
      {
        field: "owner.id",
        operator: "eq",
        value: owner,
      },
      { field: "gestore", operator: "eq", value: "false" },
    ],
    onSearch: (value) => [
      {
        field: "businessName",
        operator: "contains",
        value,
      },
    ],
  });

  const columsMemo = useMemo(
    () => [
      { field: "firstName", headerName: "Nome", flex: 1, minWidth: 150 },
      { field: "lastName", headerName: "Cognome", flex: 1, minWidth: 150 },
      { field: "email", headerName: "Email", flex: 1, minWidth: 150 },
      { field: "phone", headerName: "Telefono", flex: 1, minWidth: 150 },
      /*{
      field: "discount",
      headerName: "Sconto",
      valueGetter: ({ row }) => {
        const value = row?.discount;
        return `${value} %`;
      },
      flex: 1,
      minWidth: 300,
    },*/
      {
        headerName: "Azioni",
        field: "actions",
        minWidth: 100,
        renderCell: function render(params) {
          return (
            <Stack direction="row" spacing={1}>
              <DeleteButton
                hideText
                recordItemId={params.row.id}
                onClick={() => {
                  removeUser(params.row.id);
                }}
              />
            </Stack>
          );
        },
      },
    ],
    []
  );

  const fields = [
    {
      label: "Nome",
      name: "name",
      required: true,
      type: "text",
      md: 6,
      //localized: false,
    },
    {
      label: "Sconto %",
      name: "discount",
      required: true,
      type: "number",
      md: 6,
    },
    {
      label: "Struttura",
      name: "struttura",
      accessor: "businessName",
      options: facilityAC,
      required: true,
      type: "autocomplete",
    },
    { type: "divider" },
    {
      type: "title",
      variant: "h6",
      label: "Utenti associati al listino",
    },
  ];

  return (
    <Grid container spacing={2}>
      {fields.map((field, index) => {
        return (
          <AutoGeneratedInputCmp
            key={index}
            disabled={disabled}
            {...field}
            register={register}
            control={control}
            errors={errors}
            setError={setError}
            fieldVariants="outlined"
            defaultValue={watch(field.name)}
            defaultLanguageRecord={defaultLanguageRecord}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        );
      })}

      {/* List of users in listino */}
      <Grid item xs={12} container justifyContent="flex-end">
        <Button
          variant="contained"
          startIcon={<AddCircleIcon />}
          onClick={() => {
            if (isCreate) {
              toast.error(
                "E' necessario salvare il listino prima di poter aggiungere gli utenti"
              );
            } else {
              handleOpen();
            }
          }}
        >
          Aggiungi utente
        </Button>
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={getValues("users") || []}
          localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
          columns={columsMemo}
          /*sortingMode={sortingMode}
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}*/
          autoHeight
        />
      </Grid>
      <ModalAdd
        open={openModal}
        handleClose={handleClose}
        listinoID={listinoID}
        strutturaID={getValues("struttura")?.id}
      />
    </Grid>
  );
}
